import React from "react";
import ReactECharts from 'echarts-for-react';

const option = {
    title: {
        text: 'Led Cards by View',
        subtext: '',
        left: 'center',
        textStyle: {
            fontSize: 14, 
            fontWeight: 'normal', 
            color: '#2E2E30' 
        }
    },
    legend: {
        data: ['View', 'Lead'],
        top: 'bottom'
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            data: ['10', '11', '12', '13', '14', '15']
        }
    ],
    yAxis: [
        {
            type: 'value'
        }
    ],
    series: [
        {
            name: 'View',
            type: 'bar',
            data: [320, 332, 301, 334, 390, 330, 320],
            color: '#056CF2',
            barWidth: '7px',
            itemStyle: {
                borderRadius: [15],
            }
        },
        {
            name: 'Lead',
            type: 'bar',
            data: [862, 1018, 964, 1026, 1679, 1600, 1570],
            color: '#FF9900',
            barWidth: '7px',
            itemStyle: {
                borderRadius: [15],
            }
            
        }
        
    ]
};
const LeadViewChart = () => {
    return (
        <div className='top-card-chart'>
            <ReactECharts option={option} lazyUpdate={true} opts={{renderer: 'svg'}}/>
        </div>
    );
}
export default LeadViewChart;